import BaseMapWrapper from "../utils/BaseMapWrapper";
import AMapService from "./map";
export default class AMapWrapper extends BaseMapWrapper {
  getServiceConstructor() {
    return AMapService;
  }
}